//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum BulkUploadErrorSource {
  /**
   * Errors from backend validation of individual products in the CSV/Excel file
   * These errors are tied to specific products by their ID
   * Example:
   * - "Product ABC123: Price must be greater than 0"
   * - "Product XYZ789: Description is required"
   */
  PRODUCT = 'product',

  /**
   * General backend errors during file processing
   * These are NOT tied to specific products
   * Example:
   * - "400 Bad Request"
   */
  BACKEND = 'backend',

  /**
   * Frontend validation errors before the file is sent to backend
   * Related to the file itself, not its contents
   * Example:
   * - "File size exceeds 5MB limit"
   * - "Only CSV and Excel files are supported"
   * - "File is empty"
   */
  FILE = 'file',
}

/**
 * Represents an error that occurred during the product import process
 */
export interface BulkUploadProductError {
  /**
   * The ID of the product that failed validation
   * Only present when source is ErrorSource.PRODUCT
   * Example: "ABC123", "XYZ789"
   */
  productId?: string;

  /**
   * Indicates where this error originated
   */
  source: BulkUploadErrorSource;

  /**
   * List of error messages
   * - For PRODUCT: validation errors for that specific product
   * - For BACKEND: general processing errors
   * - For FILE: file validation errors
   */
  errors: string[];
}
